<div class="d-flex justify-content-between align-items-center" mat-dialog-title>
    <h1 class="condensed">
        Hernoemen
    </h1>
</div>
<div class="dialog-content mt-3" mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Naam</mat-label>
            <input formControlName="name" id="name" matInput name="name" placeholder="Naam" type="text">
            <mat-error>Dit veld mag maximaal 255 tekens bevatten</mat-error>
        </mat-form-field>
    </form>
</div>
<div class="d-flex flex-wrap justify-content-between" mat-dialog-actions>
    <button [mat-dialog-close]="false" mat-button>Annuleren</button>
    <div class="spacer"></div>
    <button (click)="save()" [disabled]="saving() || !form.valid" cdkFocusInitial color="primary" mat-raised-button>
        Opslaan
        @if (saving()) {
            <i class="fas fa-circle-notch fa-spin"></i>
        }
    </button>
</div>
